import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWrench = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30.711 12.89L27.626 15.961L24.026 12.378L27.11 9.30697C26.3751 9.09771 25.6141 8.99434 24.85 8.99997C23.4246 9.12246 22.0995 9.78353 21.1444 10.8486C20.1893 11.9137 19.676 13.3027 19.709 14.733C19.7021 15.2941 19.8072 15.8509 20.018 16.371L10.147 25.071C9.80478 25.3763 9.52735 25.7473 9.33114 26.1619C9.13493 26.5764 9.02393 27.0262 9.00472 27.4844C8.98551 27.9427 9.05848 28.4001 9.2193 28.8296C9.38013 29.2592 9.62554 29.652 9.94099 29.985V29.985C10.2642 30.3225 10.6556 30.5874 11.0891 30.7619C11.5226 30.9365 11.9884 31.0167 12.4553 30.9973C12.9222 30.9779 13.3797 30.8594 13.7972 30.6495C14.2148 30.4396 14.5829 30.1432 14.877 29.78L23.616 19.953C24.55 20.2265 25.5321 20.2947 26.495 20.153C27.5098 19.943 28.4481 19.4604 29.2091 18.757C29.9701 18.0537 30.525 17.1561 30.814 16.161C31.0888 15.0827 31.0531 13.9488 30.711 12.89V12.89Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgWrench);
export default ForwardRef;
